export function formatPhoneNumber(phoneNumber: string): string {
  return (
    phoneNumber.slice(0, 3) +
    '-' +
    phoneNumber.slice(3, 6) +
    '-' +
    phoneNumber.slice(6, 15)
  )
}
